import {
  breakpointSizes,
  getBreakpointOnly,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface HeaderProps {
  className?: string
}

const Header: React.FC<React.PropsWithChildren<HeaderProps>> = (
  props,
): React.ReactElement => {
  return (
    <div
      className={props.className}
      css={css`
        background-color: ${styleConstants.colors.white};
        padding: ${styleConstants.heights.headerPaddingLGUp}
          ${styleConstants.widths.headerPaddingXLGUp};
        display: flex;
        flex-direction: column;
        position: relative;
        z-index: 3;

        ${getBreakpointOnly(breakpointSizes.XXSM)(css`
          padding: ${styleConstants.heights.headerPaddingMDDown}
            ${styleConstants.widths.headerPaddingXXSMOnly};
        `)}
        ${getBreakpointOnly(breakpointSizes.XSM)(css`
          padding: ${styleConstants.heights.headerPaddingMDDown}
            ${styleConstants.widths.headerPaddingXSMOnly};
        `)}
      ${getBreakpointOnly(breakpointSizes.SM)(css`
          padding: ${styleConstants.heights.headerPaddingMDDown}
            ${styleConstants.widths.headerPaddingSMOnly};
        `)}
      ${getBreakpointOnly(breakpointSizes.MD)(css`
          padding: ${styleConstants.heights.headerPaddingMDDown}
            ${styleConstants.widths.headerPaddingMDOnly};
        `)}
      ${getBreakpointOnly(breakpointSizes.LG)(css`
          padding: ${styleConstants.heights.headerPaddingMDDown}
            ${styleConstants.widths.headerPaddingLGOnly};
        `)}
      `}
    >
      {props.children}
    </div>
  )
}

export default Header
